"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
// THIS FILE WAS CREATED AUTOMATICALLY. DO NOT MODIFY
const tokens = exports.tokens = {
  'text.size.50': '--st-dt-text-size-50',
  'text.size.100': '--st-dt-text-size-100',
  'text.size.200': '--st-dt-text-size-200',
  'text.size.300': '--st-dt-text-size-300',
  'text.size.400': '--st-dt-text-size-400',
  'text.size.500': '--st-dt-text-size-500',
  'text.size.600': '--st-dt-text-size-600',
  'text.size.700': '--st-dt-text-size-700',
  'text.size.800': '--st-dt-text-size-800',
  'text.size.900': '--st-dt-text-size-900',
  'text.style.italic': '--st-dt-text-style-italic',
  'text.family.default': '--st-dt-text-family-default',
  'text.lineHeight.50': '--st-dt-text-lineHeight-50',
  'text.lineHeight.100': '--st-dt-text-lineHeight-100',
  'text.lineHeight.150': '--st-dt-text-lineHeight-150',
  'text.lineHeight.200': '--st-dt-text-lineHeight-200',
  'text.lineHeight.250': '--st-dt-text-lineHeight-250',
  'text.lineHeight.300': '--st-dt-text-lineHeight-300',
  'text.lineHeight.400': '--st-dt-text-lineHeight-400',
  'text.lineHeight.500': '--st-dt-text-lineHeight-500',
  'text.lineHeight.600': '--st-dt-text-lineHeight-600',
  'text.lineHeight.700': '--st-dt-text-lineHeight-700',
  'text.lineHeight.800': '--st-dt-text-lineHeight-800',
  'text.display.size.breakpoint-xl': '--st-dt-text-display-size-breakpoint-xl',
  'text.display.size.breakpoint-lg': '--st-dt-text-display-size-breakpoint-lg',
  'text.display.size.breakpoint-md': '--st-dt-text-display-size-breakpoint-md',
  'text.display.size.breakpoint-sm': '--st-dt-text-display-size-breakpoint-sm',
  'text.display.weight.breakpoint-xl': '--st-dt-text-display-weight-breakpoint-xl',
  'text.display.weight.breakpoint-lg': '--st-dt-text-display-weight-breakpoint-lg',
  'text.display.weight.breakpoint-md': '--st-dt-text-display-weight-breakpoint-md',
  'text.display.weight.breakpoint-sm': '--st-dt-text-display-weight-breakpoint-sm',
  'text.display.lineHeight.breakpoint-xl': '--st-dt-text-display-lineHeight-breakpoint-xl',
  'text.display.lineHeight.breakpoint-lg': '--st-dt-text-display-lineHeight-breakpoint-lg',
  'text.display.lineHeight.breakpoint-md': '--st-dt-text-display-lineHeight-breakpoint-md',
  'text.display.lineHeight.breakpoint-sm': '--st-dt-text-display-lineHeight-breakpoint-sm',
  'text.weight.regular': '--st-dt-text-weight-regular',
  'text.weight.medium': '--st-dt-text-weight-medium',
  'text.weight.bold': '--st-dt-text-weight-bold',
  'text.heading.xl.size.breakpoint-xl': '--st-dt-text-heading-xl-size-breakpoint-xl',
  'text.heading.xl.size.breakpoint-lg': '--st-dt-text-heading-xl-size-breakpoint-lg',
  'text.heading.xl.size.breakpoint-md': '--st-dt-text-heading-xl-size-breakpoint-md',
  'text.heading.xl.size.breakpoint-sm': '--st-dt-text-heading-xl-size-breakpoint-sm',
  'text.heading.xl.weight.breakpoint-xl': '--st-dt-text-heading-xl-weight-breakpoint-xl',
  'text.heading.xl.weight.breakpoint-lg': '--st-dt-text-heading-xl-weight-breakpoint-lg',
  'text.heading.xl.weight.breakpoint-md': '--st-dt-text-heading-xl-weight-breakpoint-md',
  'text.heading.xl.weight.breakpoint-sm': '--st-dt-text-heading-xl-weight-breakpoint-sm',
  'text.heading.xl.lineHeight.breakpoint-xl': '--st-dt-text-heading-xl-lineHeight-breakpoint-xl',
  'text.heading.xl.lineHeight.breakpoint-lg': '--st-dt-text-heading-xl-lineHeight-breakpoint-lg',
  'text.heading.xl.lineHeight.breakpoint-md': '--st-dt-text-heading-xl-lineHeight-breakpoint-md',
  'text.heading.xl.lineHeight.breakpoint-sm': '--st-dt-text-heading-xl-lineHeight-breakpoint-sm',
  'text.heading.lg.size.breakpoint-xl': '--st-dt-text-heading-lg-size-breakpoint-xl',
  'text.heading.lg.size.breakpoint-lg': '--st-dt-text-heading-lg-size-breakpoint-lg',
  'text.heading.lg.size.breakpoint-md': '--st-dt-text-heading-lg-size-breakpoint-md',
  'text.heading.lg.size.breakpoint-sm': '--st-dt-text-heading-lg-size-breakpoint-sm',
  'text.heading.lg.weight.breakpoint-xl': '--st-dt-text-heading-lg-weight-breakpoint-xl',
  'text.heading.lg.weight.breakpoint-lg': '--st-dt-text-heading-lg-weight-breakpoint-lg',
  'text.heading.lg.weight.breakpoint-md': '--st-dt-text-heading-lg-weight-breakpoint-md',
  'text.heading.lg.weight.breakpoint-sm': '--st-dt-text-heading-lg-weight-breakpoint-sm',
  'text.heading.lg.lineHeight.breakpoint-xl': '--st-dt-text-heading-lg-lineHeight-breakpoint-xl',
  'text.heading.lg.lineHeight.breakpoint-lg': '--st-dt-text-heading-lg-lineHeight-breakpoint-lg',
  'text.heading.lg.lineHeight.breakpoint-md': '--st-dt-text-heading-lg-lineHeight-breakpoint-md',
  'text.heading.lg.lineHeight.breakpoint-sm': '--st-dt-text-heading-lg-lineHeight-breakpoint-sm',
  'text.heading.md.size.breakpoint-xl': '--st-dt-text-heading-md-size-breakpoint-xl',
  'text.heading.md.size.breakpoint-lg': '--st-dt-text-heading-md-size-breakpoint-lg',
  'text.heading.md.size.breakpoint-md': '--st-dt-text-heading-md-size-breakpoint-md',
  'text.heading.md.size.breakpoint-sm': '--st-dt-text-heading-md-size-breakpoint-sm',
  'text.heading.md.weight.breakpoint-xl': '--st-dt-text-heading-md-weight-breakpoint-xl',
  'text.heading.md.weight.breakpoint-lg': '--st-dt-text-heading-md-weight-breakpoint-lg',
  'text.heading.md.weight.breakpoint-md': '--st-dt-text-heading-md-weight-breakpoint-md',
  'text.heading.md.weight.breakpoint-sm': '--st-dt-text-heading-md-weight-breakpoint-sm',
  'text.heading.md.lineHeight.breakpoint-xl': '--st-dt-text-heading-md-lineHeight-breakpoint-xl',
  'text.heading.md.lineHeight.breakpoint-lg': '--st-dt-text-heading-md-lineHeight-breakpoint-lg',
  'text.heading.md.lineHeight.breakpoint-md': '--st-dt-text-heading-md-lineHeight-breakpoint-md',
  'text.heading.md.lineHeight.breakpoint-sm': '--st-dt-text-heading-md-lineHeight-breakpoint-sm',
  'text.heading.sm.size.breakpoint-xl': '--st-dt-text-heading-sm-size-breakpoint-xl',
  'text.heading.sm.size.breakpoint-lg': '--st-dt-text-heading-sm-size-breakpoint-lg',
  'text.heading.sm.size.breakpoint-md': '--st-dt-text-heading-sm-size-breakpoint-md',
  'text.heading.sm.size.breakpoint-sm': '--st-dt-text-heading-sm-size-breakpoint-sm',
  'text.heading.sm.weight.breakpoint-xl': '--st-dt-text-heading-sm-weight-breakpoint-xl',
  'text.heading.sm.weight.breakpoint-lg': '--st-dt-text-heading-sm-weight-breakpoint-lg',
  'text.heading.sm.weight.breakpoint-md': '--st-dt-text-heading-sm-weight-breakpoint-md',
  'text.heading.sm.weight.breakpoint-sm': '--st-dt-text-heading-sm-weight-breakpoint-sm',
  'text.heading.sm.lineHeight.breakpoint-xl': '--st-dt-text-heading-sm-lineHeight-breakpoint-xl',
  'text.heading.sm.lineHeight.breakpoint-lg': '--st-dt-text-heading-sm-lineHeight-breakpoint-lg',
  'text.heading.sm.lineHeight.breakpoint-md': '--st-dt-text-heading-sm-lineHeight-breakpoint-md',
  'text.heading.sm.lineHeight.breakpoint-sm': '--st-dt-text-heading-sm-lineHeight-breakpoint-sm',
  'text.heading.xs.size.breakpoint-xl': '--st-dt-text-heading-xs-size-breakpoint-xl',
  'text.heading.xs.size.breakpoint-lg': '--st-dt-text-heading-xs-size-breakpoint-lg',
  'text.heading.xs.size.breakpoint-md': '--st-dt-text-heading-xs-size-breakpoint-md',
  'text.heading.xs.size.breakpoint-sm': '--st-dt-text-heading-xs-size-breakpoint-sm',
  'text.heading.xs.weight.breakpoint-xl': '--st-dt-text-heading-xs-weight-breakpoint-xl',
  'text.heading.xs.weight.breakpoint-lg': '--st-dt-text-heading-xs-weight-breakpoint-lg',
  'text.heading.xs.weight.breakpoint-md': '--st-dt-text-heading-xs-weight-breakpoint-md',
  'text.heading.xs.weight.breakpoint-sm': '--st-dt-text-heading-xs-weight-breakpoint-sm',
  'text.heading.xs.lineHeight.breakpoint-xl': '--st-dt-text-heading-xs-lineHeight-breakpoint-xl',
  'text.heading.xs.lineHeight.breakpoint-lg': '--st-dt-text-heading-xs-lineHeight-breakpoint-lg',
  'text.heading.xs.lineHeight.breakpoint-md': '--st-dt-text-heading-xs-lineHeight-breakpoint-md',
  'text.heading.xs.lineHeight.breakpoint-sm': '--st-dt-text-heading-xs-lineHeight-breakpoint-sm',
  'text.heading.xxs.size.breakpoint-xl': '--st-dt-text-heading-xxs-size-breakpoint-xl',
  'text.heading.xxs.size.breakpoint-lg': '--st-dt-text-heading-xxs-size-breakpoint-lg',
  'text.heading.xxs.size.breakpoint-md': '--st-dt-text-heading-xxs-size-breakpoint-md',
  'text.heading.xxs.size.breakpoint-sm': '--st-dt-text-heading-xxs-size-breakpoint-sm',
  'text.heading.xxs.weight.breakpoint-xl': '--st-dt-text-heading-xxs-weight-breakpoint-xl',
  'text.heading.xxs.weight.breakpoint-lg': '--st-dt-text-heading-xxs-weight-breakpoint-lg',
  'text.heading.xxs.weight.breakpoint-md': '--st-dt-text-heading-xxs-weight-breakpoint-md',
  'text.heading.xxs.weight.breakpoint-sm': '--st-dt-text-heading-xxs-weight-breakpoint-sm',
  'text.heading.xxs.lineHeight.breakpoint-xl': '--st-dt-text-heading-xxs-lineHeight-breakpoint-xl',
  'text.heading.xxs.lineHeight.breakpoint-lg': '--st-dt-text-heading-xxs-lineHeight-breakpoint-lg',
  'text.heading.xxs.lineHeight.breakpoint-md': '--st-dt-text-heading-xxs-lineHeight-breakpoint-md',
  'text.heading.xxs.lineHeight.breakpoint-sm': '--st-dt-text-heading-xxs-lineHeight-breakpoint-sm',
  'text.body.md.size.breakpoint-xl': '--st-dt-text-body-md-size-breakpoint-xl',
  'text.body.md.size.breakpoint-lg': '--st-dt-text-body-md-size-breakpoint-lg',
  'text.body.md.size.breakpoint-md': '--st-dt-text-body-md-size-breakpoint-md',
  'text.body.md.size.breakpoint-sm': '--st-dt-text-body-md-size-breakpoint-sm',
  'text.body.md.weight.breakpoint-xl': '--st-dt-text-body-md-weight-breakpoint-xl',
  'text.body.md.weight.breakpoint-lg': '--st-dt-text-body-md-weight-breakpoint-lg',
  'text.body.md.weight.breakpoint-md': '--st-dt-text-body-md-weight-breakpoint-md',
  'text.body.md.weight.breakpoint-sm': '--st-dt-text-body-md-weight-breakpoint-sm',
  'text.body.md.lineHeight.breakpoint-xl': '--st-dt-text-body-md-lineHeight-breakpoint-xl',
  'text.body.md.lineHeight.breakpoint-lg': '--st-dt-text-body-md-lineHeight-breakpoint-lg',
  'text.body.md.lineHeight.breakpoint-md': '--st-dt-text-body-md-lineHeight-breakpoint-md',
  'text.body.md.lineHeight.breakpoint-sm': '--st-dt-text-body-md-lineHeight-breakpoint-sm',
  'text.body.sm.size.breakpoint-xl': '--st-dt-text-body-sm-size-breakpoint-xl',
  'text.body.sm.size.breakpoint-lg': '--st-dt-text-body-sm-size-breakpoint-lg',
  'text.body.sm.size.breakpoint-md': '--st-dt-text-body-sm-size-breakpoint-md',
  'text.body.sm.size.breakpoint-sm': '--st-dt-text-body-sm-size-breakpoint-sm',
  'text.body.sm.weight.breakpoint-xl': '--st-dt-text-body-sm-weight-breakpoint-xl',
  'text.body.sm.weight.breakpoint-lg': '--st-dt-text-body-sm-weight-breakpoint-lg',
  'text.body.sm.weight.breakpoint-md': '--st-dt-text-body-sm-weight-breakpoint-md',
  'text.body.sm.weight.breakpoint-sm': '--st-dt-text-body-sm-weight-breakpoint-sm',
  'text.body.sm.lineHeight.breakpoint-xl': '--st-dt-text-body-sm-lineHeight-breakpoint-xl',
  'text.body.sm.lineHeight.breakpoint-lg': '--st-dt-text-body-sm-lineHeight-breakpoint-lg',
  'text.body.sm.lineHeight.breakpoint-md': '--st-dt-text-body-sm-lineHeight-breakpoint-md',
  'text.body.sm.lineHeight.breakpoint-sm': '--st-dt-text-body-sm-lineHeight-breakpoint-sm',
  'text.body.hint.size.breakpoint-xl': '--st-dt-text-body-hint-size-breakpoint-xl',
  'text.body.hint.size.breakpoint-lg': '--st-dt-text-body-hint-size-breakpoint-lg',
  'text.body.hint.size.breakpoint-md': '--st-dt-text-body-hint-size-breakpoint-md',
  'text.body.hint.size.breakpoint-sm': '--st-dt-text-body-hint-size-breakpoint-sm',
  'text.body.hint.weight.breakpoint-xl': '--st-dt-text-body-hint-weight-breakpoint-xl',
  'text.body.hint.weight.breakpoint-lg': '--st-dt-text-body-hint-weight-breakpoint-lg',
  'text.body.hint.weight.breakpoint-md': '--st-dt-text-body-hint-weight-breakpoint-md',
  'text.body.hint.weight.breakpoint-sm': '--st-dt-text-body-hint-weight-breakpoint-sm',
  'text.body.hint.lineHeight.breakpoint-xl': '--st-dt-text-body-hint-lineHeight-breakpoint-xl',
  'text.body.hint.lineHeight.breakpoint-lg': '--st-dt-text-body-hint-lineHeight-breakpoint-lg',
  'text.body.hint.lineHeight.breakpoint-md': '--st-dt-text-body-hint-lineHeight-breakpoint-md',
  'text.body.hint.lineHeight.breakpoint-sm': '--st-dt-text-body-hint-lineHeight-breakpoint-sm',
  'text.body.hint.style.breakpoint-xl': '--st-dt-text-body-hint-style-breakpoint-xl',
  'text.body.hint.style.breakpoint-lg': '--st-dt-text-body-hint-style-breakpoint-lg',
  'text.body.hint.style.breakpoint-md': '--st-dt-text-body-hint-style-breakpoint-md',
  'text.body.hint.style.breakpoint-sm': '--st-dt-text-body-hint-style-breakpoint-sm',
  'text.body.lg.size.breakpoint-xl': '--st-dt-text-body-lg-size-breakpoint-xl',
  'text.body.lg.size.breakpoint-lg': '--st-dt-text-body-lg-size-breakpoint-lg',
  'text.body.lg.size.breakpoint-md': '--st-dt-text-body-lg-size-breakpoint-md',
  'text.body.lg.size.breakpoint-sm': '--st-dt-text-body-lg-size-breakpoint-sm',
  'text.body.lg.weight.breakpoint-xl': '--st-dt-text-body-lg-weight-breakpoint-xl',
  'text.body.lg.weight.breakpoint-lg': '--st-dt-text-body-lg-weight-breakpoint-lg',
  'text.body.lg.weight.breakpoint-md': '--st-dt-text-body-lg-weight-breakpoint-md',
  'text.body.lg.weight.breakpoint-sm': '--st-dt-text-body-lg-weight-breakpoint-sm',
  'text.body.lg.lineHeight.breakpoint-xl': '--st-dt-text-body-lg-lineHeight-breakpoint-xl',
  'text.body.lg.lineHeight.breakpoint-lg': '--st-dt-text-body-lg-lineHeight-breakpoint-lg',
  'text.body.lg.lineHeight.breakpoint-md': '--st-dt-text-body-lg-lineHeight-breakpoint-md',
  'text.body.lg.lineHeight.breakpoint-sm': '--st-dt-text-body-lg-lineHeight-breakpoint-sm',
  'text.body.sm-interactive.size.breakpoint-xl': '--st-dt-text-body-sm-interactive-size-breakpoint-xl',
  'text.body.sm-interactive.size.breakpoint-lg': '--st-dt-text-body-sm-interactive-size-breakpoint-lg',
  'text.body.sm-interactive.size.breakpoint-md': '--st-dt-text-body-sm-interactive-size-breakpoint-md',
  'text.body.sm-interactive.size.breakpoint-sm': '--st-dt-text-body-sm-interactive-size-breakpoint-sm',
  'text.body.sm-interactive.weight.breakpoint-xl': '--st-dt-text-body-sm-interactive-weight-breakpoint-xl',
  'text.body.sm-interactive.weight.breakpoint-lg': '--st-dt-text-body-sm-interactive-weight-breakpoint-lg',
  'text.body.sm-interactive.weight.breakpoint-md': '--st-dt-text-body-sm-interactive-weight-breakpoint-md',
  'text.body.sm-interactive.weight.breakpoint-sm': '--st-dt-text-body-sm-interactive-weight-breakpoint-sm',
  'text.body.sm-interactive.lineHeight.breakpoint-xl': '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-xl',
  'text.body.sm-interactive.lineHeight.breakpoint-lg': '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-lg',
  'text.body.sm-interactive.lineHeight.breakpoint-md': '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-md',
  'text.body.sm-interactive.lineHeight.breakpoint-sm': '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-sm',
  'text.body.md-interactive.size.breakpoint-xl': '--st-dt-text-body-md-interactive-size-breakpoint-xl',
  'text.body.md-interactive.size.breakpoint-lg': '--st-dt-text-body-md-interactive-size-breakpoint-lg',
  'text.body.md-interactive.size.breakpoint-md': '--st-dt-text-body-md-interactive-size-breakpoint-md',
  'text.body.md-interactive.size.breakpoint-sm': '--st-dt-text-body-md-interactive-size-breakpoint-sm',
  'text.body.md-interactive.weight.breakpoint-xl': '--st-dt-text-body-md-interactive-weight-breakpoint-xl',
  'text.body.md-interactive.weight.breakpoint-lg': '--st-dt-text-body-md-interactive-weight-breakpoint-lg',
  'text.body.md-interactive.weight.breakpoint-md': '--st-dt-text-body-md-interactive-weight-breakpoint-md',
  'text.body.md-interactive.weight.breakpoint-sm': '--st-dt-text-body-md-interactive-weight-breakpoint-sm',
  'text.body.md-interactive.lineHeight.breakpoint-xl': '--st-dt-text-body-md-interactive-lineHeight-breakpoint-xl',
  'text.body.md-interactive.lineHeight.breakpoint-lg': '--st-dt-text-body-md-interactive-lineHeight-breakpoint-lg',
  'text.body.md-interactive.lineHeight.breakpoint-md': '--st-dt-text-body-md-interactive-lineHeight-breakpoint-md',
  'text.body.md-interactive.lineHeight.breakpoint-sm': '--st-dt-text-body-md-interactive-lineHeight-breakpoint-sm',
  'text.body.lg-interactive.size.breakpoint-xl': '--st-dt-text-body-lg-interactive-size-breakpoint-xl',
  'text.body.lg-interactive.size.breakpoint-lg': '--st-dt-text-body-lg-interactive-size-breakpoint-lg',
  'text.body.lg-interactive.size.breakpoint-md': '--st-dt-text-body-lg-interactive-size-breakpoint-md',
  'text.body.lg-interactive.size.breakpoint-sm': '--st-dt-text-body-lg-interactive-size-breakpoint-sm',
  'text.body.lg-interactive.weight.breakpoint-xl': '--st-dt-text-body-lg-interactive-weight-breakpoint-xl',
  'text.body.lg-interactive.weight.breakpoint-lg': '--st-dt-text-body-lg-interactive-weight-breakpoint-lg',
  'text.body.lg-interactive.weight.breakpoint-md': '--st-dt-text-body-lg-interactive-weight-breakpoint-md',
  'text.body.lg-interactive.weight.breakpoint-sm': '--st-dt-text-body-lg-interactive-weight-breakpoint-sm',
  'text.body.lg-interactive.lineHeight.breakpoint-xl': '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-xl',
  'text.body.lg-interactive.lineHeight.breakpoint-lg': '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-lg',
  'text.body.lg-interactive.lineHeight.breakpoint-md': '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-md',
  'text.body.lg-interactive.lineHeight.breakpoint-sm': '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-sm',
  'text.label.md.size.breakpoint-xl': '--st-dt-text-label-md-size-breakpoint-xl',
  'text.label.md.size.breakpoint-lg': '--st-dt-text-label-md-size-breakpoint-lg',
  'text.label.md.size.breakpoint-md': '--st-dt-text-label-md-size-breakpoint-md',
  'text.label.md.size.breakpoint-sm': '--st-dt-text-label-md-size-breakpoint-sm',
  'text.label.md.weight.breakpoint-xl': '--st-dt-text-label-md-weight-breakpoint-xl',
  'text.label.md.weight.breakpoint-lg': '--st-dt-text-label-md-weight-breakpoint-lg',
  'text.label.md.weight.breakpoint-md': '--st-dt-text-label-md-weight-breakpoint-md',
  'text.label.md.weight.breakpoint-sm': '--st-dt-text-label-md-weight-breakpoint-sm',
  'text.label.md.lineHeight.breakpoint-xl': '--st-dt-text-label-md-lineHeight-breakpoint-xl',
  'text.label.md.lineHeight.breakpoint-lg': '--st-dt-text-label-md-lineHeight-breakpoint-lg',
  'text.label.md.lineHeight.breakpoint-md': '--st-dt-text-label-md-lineHeight-breakpoint-md',
  'text.label.md.lineHeight.breakpoint-sm': '--st-dt-text-label-md-lineHeight-breakpoint-sm',
  'text.label.sm.size.breakpoint-xl': '--st-dt-text-label-sm-size-breakpoint-xl',
  'text.label.sm.size.breakpoint-lg': '--st-dt-text-label-sm-size-breakpoint-lg',
  'text.label.sm.size.breakpoint-md': '--st-dt-text-label-sm-size-breakpoint-md',
  'text.label.sm.size.breakpoint-sm': '--st-dt-text-label-sm-size-breakpoint-sm',
  'text.label.sm.weight.breakpoint-xl': '--st-dt-text-label-sm-weight-breakpoint-xl',
  'text.label.sm.weight.breakpoint-lg': '--st-dt-text-label-sm-weight-breakpoint-lg',
  'text.label.sm.weight.breakpoint-md': '--st-dt-text-label-sm-weight-breakpoint-md',
  'text.label.sm.weight.breakpoint-sm': '--st-dt-text-label-sm-weight-breakpoint-sm',
  'text.label.sm.lineHeight.breakpoint-xl': '--st-dt-text-label-sm-lineHeight-breakpoint-xl',
  'text.label.sm.lineHeight.breakpoint-lg': '--st-dt-text-label-sm-lineHeight-breakpoint-lg',
  'text.label.sm.lineHeight.breakpoint-md': '--st-dt-text-label-sm-lineHeight-breakpoint-md',
  'text.label.sm.lineHeight.breakpoint-sm': '--st-dt-text-label-sm-lineHeight-breakpoint-sm',
  'text.label.xs.size.breakpoint-xl': '--st-dt-text-label-xs-size-breakpoint-xl',
  'text.label.xs.size.breakpoint-lg': '--st-dt-text-label-xs-size-breakpoint-lg',
  'text.label.xs.size.breakpoint-md': '--st-dt-text-label-xs-size-breakpoint-md',
  'text.label.xs.size.breakpoint-sm': '--st-dt-text-label-xs-size-breakpoint-sm',
  'text.label.xs.weight.breakpoint-xl': '--st-dt-text-label-xs-weight-breakpoint-xl',
  'text.label.xs.weight.breakpoint-lg': '--st-dt-text-label-xs-weight-breakpoint-lg',
  'text.label.xs.weight.breakpoint-md': '--st-dt-text-label-xs-weight-breakpoint-md',
  'text.label.xs.weight.breakpoint-sm': '--st-dt-text-label-xs-weight-breakpoint-sm',
  'text.label.xs.lineHeight.breakpoint-xl': '--st-dt-text-label-xs-lineHeight-breakpoint-xl',
  'text.label.xs.lineHeight.breakpoint-lg': '--st-dt-text-label-xs-lineHeight-breakpoint-lg',
  'text.label.xs.lineHeight.breakpoint-md': '--st-dt-text-label-xs-lineHeight-breakpoint-md',
  'text.label.xs.lineHeight.breakpoint-sm': '--st-dt-text-label-xs-lineHeight-breakpoint-sm',
  'color.neutral.10': '--st-dt-color-neutral-10',
  'color.neutral.20': '--st-dt-color-neutral-20',
  'color.neutral.30': '--st-dt-color-neutral-30',
  'color.neutral.40': '--st-dt-color-neutral-40',
  'color.neutral.50': '--st-dt-color-neutral-50',
  'color.neutral.60': '--st-dt-color-neutral-60',
  'color.neutral.70': '--st-dt-color-neutral-70',
  'color.neutral.80': '--st-dt-color-neutral-80',
  'color.neutral.90': '--st-dt-color-neutral-90',
  'color.neutral.100': '--st-dt-color-neutral-100',
  'color.neutral.00': '--st-dt-color-neutral-00',
  'color.neutral.05': '--st-dt-color-neutral-05',
  'color.blue.10': '--st-dt-color-blue-10',
  'color.blue.20': '--st-dt-color-blue-20',
  'color.blue.30': '--st-dt-color-blue-30',
  'color.blue.40': '--st-dt-color-blue-40',
  'color.blue.50': '--st-dt-color-blue-50',
  'color.blue.60': '--st-dt-color-blue-60',
  'color.blue.70': '--st-dt-color-blue-70',
  'color.blue.80': '--st-dt-color-blue-80',
  'color.blue.90': '--st-dt-color-blue-90',
  'color.blue.05': '--st-dt-color-blue-05',
  'color.green.10': '--st-dt-color-green-10',
  'color.green.20': '--st-dt-color-green-20',
  'color.green.30': '--st-dt-color-green-30',
  'color.green.40': '--st-dt-color-green-40',
  'color.green.50': '--st-dt-color-green-50',
  'color.green.60': '--st-dt-color-green-60',
  'color.green.70': '--st-dt-color-green-70',
  'color.green.80': '--st-dt-color-green-80',
  'color.green.90': '--st-dt-color-green-90',
  'color.green.05': '--st-dt-color-green-05',
  'color.red.10': '--st-dt-color-red-10',
  'color.red.20': '--st-dt-color-red-20',
  'color.red.30': '--st-dt-color-red-30',
  'color.red.40': '--st-dt-color-red-40',
  'color.red.50': '--st-dt-color-red-50',
  'color.red.60': '--st-dt-color-red-60',
  'color.red.70': '--st-dt-color-red-70',
  'color.red.80': '--st-dt-color-red-80',
  'color.red.90': '--st-dt-color-red-90',
  'color.red.05': '--st-dt-color-red-05',
  'color.yellow.10': '--st-dt-color-yellow-10',
  'color.yellow.20': '--st-dt-color-yellow-20',
  'color.yellow.30': '--st-dt-color-yellow-30',
  'color.yellow.40': '--st-dt-color-yellow-40',
  'color.yellow.50': '--st-dt-color-yellow-50',
  'color.yellow.60': '--st-dt-color-yellow-60',
  'color.yellow.70': '--st-dt-color-yellow-70',
  'color.yellow.80': '--st-dt-color-yellow-80',
  'color.yellow.90': '--st-dt-color-yellow-90',
  'color.yellow.05': '--st-dt-color-yellow-05',
  'color.pink.10': '--st-dt-color-pink-10',
  'color.pink.20': '--st-dt-color-pink-20',
  'color.pink.30': '--st-dt-color-pink-30',
  'color.pink.40': '--st-dt-color-pink-40',
  'color.pink.50': '--st-dt-color-pink-50',
  'color.pink.60': '--st-dt-color-pink-60',
  'color.pink.70': '--st-dt-color-pink-70',
  'color.pink.80': '--st-dt-color-pink-80',
  'color.pink.90': '--st-dt-color-pink-90',
  'color.pink.05': '--st-dt-color-pink-05',
  'color.purple.10': '--st-dt-color-purple-10',
  'color.purple.20': '--st-dt-color-purple-20',
  'color.purple.30': '--st-dt-color-purple-30',
  'color.purple.40': '--st-dt-color-purple-40',
  'color.purple.50': '--st-dt-color-purple-50',
  'color.purple.60': '--st-dt-color-purple-60',
  'color.purple.70': '--st-dt-color-purple-70',
  'color.purple.80': '--st-dt-color-purple-80',
  'color.purple.90': '--st-dt-color-purple-90',
  'color.purple.05': '--st-dt-color-purple-05',
  'color.surface.bg-default': '--st-dt-color-surface-bg-default',
  'color.surface.bg-muted': '--st-dt-color-surface-bg-muted',
  'color.surface.overlay': '--st-dt-color-surface-overlay',
  'color.surface.dark-bg-static': '--st-dt-color-surface-dark-bg-static',
  'color.surface.bg-raised': '--st-dt-color-surface-bg-raised',
  'color.fill.neutral.primary': '--st-dt-color-fill-neutral-primary',
  'color.fill.neutral.muted': '--st-dt-color-fill-neutral-muted',
  'color.fill.neutral.secondary': '--st-dt-color-fill-neutral-secondary',
  'color.fill.neutral.tertiary': '--st-dt-color-fill-neutral-tertiary',
  'color.fill.vibrant.gray': '--st-dt-color-fill-vibrant-gray',
  'color.fill.vibrant.blue': '--st-dt-color-fill-vibrant-blue',
  'color.fill.vibrant.red': '--st-dt-color-fill-vibrant-red',
  'color.fill.vibrant.green': '--st-dt-color-fill-vibrant-green',
  'color.fill.vibrant.yellow': '--st-dt-color-fill-vibrant-yellow',
  'color.fill.vibrant.purple': '--st-dt-color-fill-vibrant-purple',
  'color.fill.vibrant.pink': '--st-dt-color-fill-vibrant-pink',
  'color.fill.muted.gray': '--st-dt-color-fill-muted-gray',
  'color.fill.muted.blue': '--st-dt-color-fill-muted-blue',
  'color.fill.muted.red': '--st-dt-color-fill-muted-red',
  'color.fill.muted.green': '--st-dt-color-fill-muted-green',
  'color.fill.muted.yellow': '--st-dt-color-fill-muted-yellow',
  'color.fill.muted.pink': '--st-dt-color-fill-muted-pink',
  'color.fill.muted.purple': '--st-dt-color-fill-muted-purple',
  'color.text.primary': '--st-dt-color-text-primary',
  'color.text.secondary': '--st-dt-color-text-secondary',
  'color.text.primary-inverted': '--st-dt-color-text-primary-inverted',
  'color.text.secondary-inverted': '--st-dt-color-text-secondary-inverted',
  'color.text.disabled': '--st-dt-color-text-disabled',
  'color.icon.primary-default': '--st-dt-color-icon-primary-default',
  'color.icon.secondary': '--st-dt-color-icon-secondary',
  'color.icon.primary-inverted-default': '--st-dt-color-icon-primary-inverted-default',
  'color.icon.secondary-inverted': '--st-dt-color-icon-secondary-inverted',
  'color.icon.interactive-default': '--st-dt-color-icon-interactive-default',
  'color.icon.interactive-hover': '--st-dt-color-icon-interactive-hover',
  'color.icon.interactive-pressed': '--st-dt-color-icon-interactive-pressed',
  'color.icon.interactive-disabled': '--st-dt-color-icon-interactive-disabled',
  'color.icon.critical-default': '--st-dt-color-icon-critical-default',
  'color.icon.critical-hover': '--st-dt-color-icon-critical-hover',
  'color.icon.critical-pressed': '--st-dt-color-icon-critical-pressed',
  'color.icon.critical-disabled': '--st-dt-color-icon-critical-disabled',
  'color.icon.primary-hover': '--st-dt-color-icon-primary-hover',
  'color.icon.primary-pressed': '--st-dt-color-icon-primary-pressed',
  'color.icon.primary-disabled': '--st-dt-color-icon-primary-disabled',
  'color.icon.primary-inverted-hover': '--st-dt-color-icon-primary-inverted-hover',
  'color.icon.primary-inverted-pressed': '--st-dt-color-icon-primary-inverted-pressed',
  'color.icon.primary-inverted-disabled': '--st-dt-color-icon-primary-inverted-disabled',
  'color.link.primary-default': '--st-dt-color-link-primary-default',
  'color.link.primary-hover': '--st-dt-color-link-primary-hover',
  'color.link.primary-pressed': '--st-dt-color-link-primary-pressed',
  'color.link.primary-disabled': '--st-dt-color-link-primary-disabled',
  'color.link.inverted-default': '--st-dt-color-link-inverted-default',
  'color.link.inverted-hover': '--st-dt-color-link-inverted-hover',
  'color.link.inverted-pressed': '--st-dt-color-link-inverted-pressed',
  'color.link.inverted-disabled': '--st-dt-color-link-inverted-disabled',
  'color.link.neutral-default': '--st-dt-color-link-neutral-default',
  'color.link.neutral-hover': '--st-dt-color-link-neutral-hover',
  'color.link.neutral-pressed': '--st-dt-color-link-neutral-pressed',
  'color.link.neutral-disabled': '--st-dt-color-link-neutral-disabled',
  'color.link.critical-default': '--st-dt-color-link-critical-default',
  'color.link.critical-hover': '--st-dt-color-link-critical-hover',
  'color.link.critical-pressed': '--st-dt-color-link-critical-pressed',
  'color.link.critical-disabled': '--st-dt-color-link-critical-disabled',
  'color.border.primary': '--st-dt-color-border-primary',
  'color.border.border-focus': '--st-dt-color-border-border-focus',
  'color.action.primary.bg-default': '--st-dt-color-action-primary-bg-default',
  'color.action.primary.bg-hover': '--st-dt-color-action-primary-bg-hover',
  'color.action.primary.bg-pressed': '--st-dt-color-action-primary-bg-pressed',
  'color.action.primary.bg-disabled': '--st-dt-color-action-primary-bg-disabled',
  'color.action.primary.critical-bg-default': '--st-dt-color-action-primary-critical-bg-default',
  'color.action.primary.critical-bg-hover': '--st-dt-color-action-primary-critical-bg-hover',
  'color.action.primary.critical-bg-pressed': '--st-dt-color-action-primary-critical-bg-pressed',
  'color.action.primary.critical-bg-disabled': '--st-dt-color-action-primary-critical-bg-disabled',
  'color.action.secondary.bg-default': '--st-dt-color-action-secondary-bg-default',
  'color.action.secondary.bg-hover': '--st-dt-color-action-secondary-bg-hover',
  'color.action.secondary.bg-pressed': '--st-dt-color-action-secondary-bg-pressed',
  'color.action.secondary.bg-disabled': '--st-dt-color-action-secondary-bg-disabled',
  'color.action.secondary.border-default': '--st-dt-color-action-secondary-border-default',
  'color.action.secondary.border-hover': '--st-dt-color-action-secondary-border-hover',
  'color.action.secondary.border-pressed': '--st-dt-color-action-secondary-border-pressed',
  'color.action.secondary.border-disabled': '--st-dt-color-action-secondary-border-disabled',
  'color.action.secondary.critical-bg-default': '--st-dt-color-action-secondary-critical-bg-default',
  'color.action.secondary.critical-bg-hover': '--st-dt-color-action-secondary-critical-bg-hover',
  'color.action.secondary.critical-bg-pressed': '--st-dt-color-action-secondary-critical-bg-pressed',
  'color.action.secondary.critical-bg-disabled': '--st-dt-color-action-secondary-critical-bg-disabled',
  'color.action.tertiary.bg-hover': '--st-dt-color-action-tertiary-bg-hover',
  'color.action.tertiary.bg-pressed': '--st-dt-color-action-tertiary-bg-pressed',
  'color.action.tertiary.critical-bg-hover': '--st-dt-color-action-tertiary-critical-bg-hover',
  'color.action.tertiary.critical-bg-pressed': '--st-dt-color-action-tertiary-critical-bg-pressed',
  'color.action.utility.bg-default': '--st-dt-color-action-utility-bg-default',
  'color.action.utility.bg-hover': '--st-dt-color-action-utility-bg-hover',
  'color.action.utility.bg-pressed': '--st-dt-color-action-utility-bg-pressed',
  'color.action.utility.selected-bg-default': '--st-dt-color-action-utility-selected-bg-default',
  'color.action.utility.selected-bg-hover': '--st-dt-color-action-utility-selected-bg-hover',
  'color.action.utility.selected-bg-pressed': '--st-dt-color-action-utility-selected-bg-pressed',
  'color.action.utility.selected-bg-disabled': '--st-dt-color-action-utility-selected-bg-disabled',
  'color.action.utility.border': '--st-dt-color-action-utility-border',
  'color.action.utility.bg-disabled': '--st-dt-color-action-utility-bg-disabled',
  'color.action.utility.selected-border': '--st-dt-color-action-utility-selected-border',
  'color.action.utility.adaptive-bg-hover': '--st-dt-color-action-utility-adaptive-bg-hover',
  'color.action.utility.adaptive-bg-pressed': '--st-dt-color-action-utility-adaptive-bg-pressed',
  'color.input.bg-default': '--st-dt-color-input-bg-default',
  'color.input.border-default': '--st-dt-color-input-border-default',
  'color.input.border-hover': '--st-dt-color-input-border-hover',
  'color.input.border-pressed': '--st-dt-color-input-border-pressed',
  'color.input.border-disabled': '--st-dt-color-input-border-disabled',
  'color.input.bg-disabled': '--st-dt-color-input-bg-disabled',
  'color.input.selected.bg-default': '--st-dt-color-input-selected-bg-default',
  'color.input.selected.bg-hover': '--st-dt-color-input-selected-bg-hover',
  'color.input.selected.bg-pressed': '--st-dt-color-input-selected-bg-pressed',
  'color.input.selected.bg-disabled': '--st-dt-color-input-selected-bg-disabled',
  'color.input.selected.critical-bg-default': '--st-dt-color-input-selected-critical-bg-default',
  'color.input.selected.critical-bg-hover': '--st-dt-color-input-selected-critical-bg-hover',
  'color.input.selected.critical-bg-pressed': '--st-dt-color-input-selected-critical-bg-pressed',
  'color.input.selected.critical-bg-disabled': '--st-dt-color-input-selected-critical-bg-disabled',
  'color.input.selected.border-default': '--st-dt-color-input-selected-border-default',
  'color.input.selected.border-disabled': '--st-dt-color-input-selected-border-disabled',
  'color.status.info-bg': '--st-dt-color-status-info-bg',
  'color.status.info-border': '--st-dt-color-status-info-border',
  'color.status.info-icon': '--st-dt-color-status-info-icon',
  'color.status.success-bg': '--st-dt-color-status-success-bg',
  'color.status.success-border-default': '--st-dt-color-status-success-border-default',
  'color.status.success-icon': '--st-dt-color-status-success-icon',
  'color.status.warning-bg': '--st-dt-color-status-warning-bg',
  'color.status.warning-border-default': '--st-dt-color-status-warning-border-default',
  'color.status.warning-icon': '--st-dt-color-status-warning-icon',
  'color.status.critical-bg': '--st-dt-color-status-critical-bg',
  'color.status.critical-border-default': '--st-dt-color-status-critical-border-default',
  'color.status.critical-icon': '--st-dt-color-status-critical-icon',
  'color.status.bias-bg': '--st-dt-color-status-bias-bg',
  'color.status.bias-border': '--st-dt-color-status-bias-border',
  'color.status.bias-icon': '--st-dt-color-status-bias-icon',
  'color.status.info-fill': '--st-dt-color-status-info-fill',
  'color.status.success-fill': '--st-dt-color-status-success-fill',
  'color.status.warning-fill': '--st-dt-color-status-warning-fill',
  'color.status.critical-fill': '--st-dt-color-status-critical-fill',
  'color.status.bias-fill': '--st-dt-color-status-bias-fill',
  'color.status.neutral-fill': '--st-dt-color-status-neutral-fill',
  'color.status.neutral-border': '--st-dt-color-status-neutral-border',
  'color.status.success-border-hover': '--st-dt-color-status-success-border-hover',
  'color.status.success-border-pressed': '--st-dt-color-status-success-border-pressed',
  'color.status.warning-border-hover': '--st-dt-color-status-warning-border-hover',
  'color.status.warning-border-pressed': '--st-dt-color-status-warning-border-pressed',
  'color.status.critical-border-hover': '--st-dt-color-status-critical-border-hover',
  'color.status.critical-border-pressed': '--st-dt-color-status-critical-border-pressed',
  'color.status.critical-border-disabled': '--st-dt-color-status-critical-border-disabled',
  'color.status.info-border-disabled': '--st-dt-color-status-info-border-disabled',
  'color.tenure.gold': '--st-dt-color-tenure-gold',
  'color.tenure.blue': '--st-dt-color-tenure-blue',
  'color.tenure.yellow': '--st-dt-color-tenure-yellow',
  'color.tenure.red': '--st-dt-color-tenure-red',
  'color.tenure.purple': '--st-dt-color-tenure-purple',
  'color.tenure.silver': '--st-dt-color-tenure-silver',
  'color.transparent.neutral90-alpha30': '--st-dt-color-transparent-neutral90-alpha30',
  'color.transparent.neutral90-alpha10': '--st-dt-color-transparent-neutral90-alpha10',
  'color.transparent.neutral90-alpha20': '--st-dt-color-transparent-neutral90-alpha20',
  'color.transparent.neutral100-alpha70': '--st-dt-color-transparent-neutral100-alpha70',
  'color.transparent.alpha0': '--st-dt-color-transparent-alpha0',
  'color.transparent.black-alpha70': '--st-dt-color-transparent-black-alpha70',
  'color.transparent.blue70-alpha30': '--st-dt-color-transparent-blue70-alpha30',
  'color.transparent.blue60-alpha70': '--st-dt-color-transparent-blue60-alpha70',
  'color.transparent.blue20-alpha30': '--st-dt-color-transparent-blue20-alpha30',
  'color.transparent.red20-alpha30': '--st-dt-color-transparent-red20-alpha30',
  'color.transparent.red70-alpha30': '--st-dt-color-transparent-red70-alpha30',
  'color.transparent.neutral05-alpha10': '--st-dt-color-transparent-neutral05-alpha10',
  'color.transparent.neutral05-alpha20': '--st-dt-color-transparent-neutral05-alpha20',
  'color.gradient.elevation': '--st-dt-color-gradient-elevation',
  'dimensions.border.radius.50': '--st-dt-dimensions-border-radius-50',
  'dimensions.border.radius.100': '--st-dt-dimensions-border-radius-100',
  'dimensions.border.radius.200': '--st-dt-dimensions-border-radius-200',
  'dimensions.border.radius.300': '--st-dt-dimensions-border-radius-300',
  'dimensions.border.radius.400': '--st-dt-dimensions-border-radius-400',
  'dimensions.border.radius.none': '--st-dt-dimensions-border-radius-none',
  'dimensions.border.radius.round': '--st-dt-dimensions-border-radius-round',
  'dimensions.border.width.100': '--st-dt-dimensions-border-width-100',
  'dimensions.border.width.200': '--st-dt-dimensions-border-width-200',
  'dimensions.border.width.300': '--st-dt-dimensions-border-width-300',
  'dimensions.border.width.400': '--st-dt-dimensions-border-width-400',
  'dimensions.border.width.500': '--st-dt-dimensions-border-width-500',
  'dimensions.border.width.none': '--st-dt-dimensions-border-width-none',
  'dimensions.z-index.100': '--st-dt-dimensions-z-index-100',
  'dimensions.z-index.200': '--st-dt-dimensions-z-index-200',
  'dimensions.z-index.300': '--st-dt-dimensions-z-index-300',
  'dimensions.z-index.400': '--st-dt-dimensions-z-index-400',
  'dimensions.z-index.500': '--st-dt-dimensions-z-index-500',
  'dimensions.z-index.600': '--st-dt-dimensions-z-index-600',
  'dimensions.z-index.700': '--st-dt-dimensions-z-index-700',
  'dimensions.z-index.800': '--st-dt-dimensions-z-index-800',
  'dimensions.z-index.900': '--st-dt-dimensions-z-index-900',
  'dimensions.z-index.1000': '--st-dt-dimensions-z-index-1000',
  'dimensions.spacing.50': '--st-dt-dimensions-spacing-50',
  'dimensions.spacing.100': '--st-dt-dimensions-spacing-100',
  'dimensions.spacing.200': '--st-dt-dimensions-spacing-200',
  'dimensions.spacing.250': '--st-dt-dimensions-spacing-250',
  'dimensions.spacing.300': '--st-dt-dimensions-spacing-300',
  'dimensions.spacing.400': '--st-dt-dimensions-spacing-400',
  'dimensions.spacing.500': '--st-dt-dimensions-spacing-500',
  'dimensions.spacing.600': '--st-dt-dimensions-spacing-600',
  'dimensions.spacing.700': '--st-dt-dimensions-spacing-700',
  'dimensions.spacing.800': '--st-dt-dimensions-spacing-800',
  'dimensions.spacing.none': '--st-dt-dimensions-spacing-none',
  'shadow.100': '--st-dt-shadow-100',
  'shadow.200': '--st-dt-shadow-200',
  'shadow.300': '--st-dt-shadow-300',
  'shadow.400': '--st-dt-shadow-400',
  'shadow.raised-rest': '--st-dt-shadow-raised-rest',
  'shadow.raised-hover': '--st-dt-shadow-raised-hover',
  'shadow.raised-pressed': '--st-dt-shadow-raised-pressed',
  'shadow.none': '--st-dt-shadow-none'
};